import { render } from "./InputNumber.vue?vue&type=template&id=7aa9babb"
import script from "./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue?vue&type=script&lang=js"
script.render = render

export default script